import { useState } from "react";
import { Link } from "react-router-dom";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";

export default function EsqueciSenha() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Erro ao enviar");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4" data-testid="forgot-page">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
        <Link to="/login" className="inline-flex items-center gap-2 text-xs text-gray-500 hover:text-[#0A1128] mb-6">
          <ArrowLeft size={14} /> Voltar ao login
        </Link>
        {!sent ? (
          <>
            <h1 className="font-display text-3xl text-[#0A1128] font-light mb-2">Esqueci minha senha</h1>
            <p className="text-sm text-gray-500 mb-6">
              Informe o e-mail cadastrado. Enviaremos um link seguro para você redefinir sua senha.
            </p>
            <form onSubmit={submit} className="space-y-3">
              <div>
                <label className="text-[10px] uppercase tracking-wider text-gray-500 font-bold flex items-center gap-1"><Mail size={12} /> E-mail</label>
                <input required type="email" autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="seu@email.com" className="w-full mt-1 border border-gray-200 rounded-lg px-4 py-3 text-sm focus:border-[#D4AF37] outline-none" data-testid="forgot-email" />
              </div>
              <button type="submit" disabled={loading} className="w-full bg-[#0A1128] text-white py-3 rounded-lg text-sm font-bold uppercase tracking-wider hover:bg-[#14213D] disabled:opacity-50" data-testid="forgot-submit">
                {loading ? "Enviando…" : "Enviar link"}
              </button>
            </form>
          </>
        ) : (
          <div className="text-center" data-testid="forgot-success">
            <CheckCircle2 size={40} className="mx-auto text-emerald-500 mb-3" />
            <h2 className="font-display text-xl text-[#0A1128] mb-2">Link enviado!</h2>
            <p className="text-sm text-gray-600">
              Se o e-mail <strong>{email}</strong> estiver cadastrado, você receberá as instruções em alguns instantes.
              O link é válido por <strong>1 hora</strong>.
            </p>
            <Link to="/login" className="inline-block mt-6 text-xs uppercase tracking-wider font-bold text-[#D4AF37] hover:underline">
              Voltar ao login
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
